import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { AppRouter } from "@/routes";
import { Toaster } from "@/components/ui/Toast";
import { AuthProvider } from "@/features/auth/AuthContext";
import { VendorAuthProvider } from "@/features/vendor-auth/VendorAuthContext";
class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (_jsx("main", { className: "min-h-screen flex items-center justify-center p-8", children: _jsxs("div", { className: "card-beam-static rounded-card p-8 max-w-md text-center space-y-4", children: [_jsx("h1", { className: "font-display italic text-3xl text-text", children: "Something went wrong" }), _jsx("p", { className: "text-text-muted text-sm", children: this.state.error.message }), _jsx("button", { className: "cta-pill", onClick: () => window.location.assign("/"), children: "Go home" })] }) }));
        }
        return this.props.children;
    }
}
// ── App root ────────────────────────────────────────────────────────────────
export default function App() {
    return (_jsx(ErrorBoundary, { children: _jsx(AuthProvider, { children: _jsxs(VendorAuthProvider, { children: [_jsx(AppRouter, {}), _jsx(Toaster, {})] }) }) }));
}
